// Dashboards hub — collects the cross-app dashboards that register
// themselves as `lib/dashboardEntries/<key>.ts` (one import-free file per
// dashboard exporting `dashboardEntry`) and merges them with the
// built-ins. Kept apart from dashboards.ts because import.meta.glob only
// exists under Vite; the pure rules stay tsx-testable there.
//
// An empty folder is fine: the glob resolves to `{}`.

import { BUILT_IN_DASHBOARDS, mergeDashboards, type DashboardEntry } from './dashboards';

const modules = import.meta.glob<{ dashboardEntry?: unknown }>('./dashboardEntries/*.ts', {
  eager: true,
});

export const DASHBOARDS: readonly DashboardEntry[] = mergeDashboards(
  BUILT_IN_DASHBOARDS,
  Object.keys(modules)
    .sort()
    .map((path) => modules[path].dashboardEntry),
);
